class CustomDialog extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);

    this.dialog = this.querySelector("dialog");
    const dataTargetValue = this.getAttribute("data-target");
    this.buttons = document.querySelectorAll(
      `button[data-target="${dataTargetValue}"]`
    );
    this.closeButton = this.querySelectorAll(`[data-dialog="close"]`);
    if (!this.dialog) return;

    this.buttons.forEach((button) => {
      button.addEventListener("click", this.handleButtonClick);
    });

    this.closeButton.forEach((button) => {
      button.addEventListener("click", () => {
        if (this.dialog.querySelector(".dialog")) {
          this.dialog.querySelector(".dialog")?.classList.add("fade-in");
        } else {
          this.dialog.classList.remove("fade-in");
        }
        this.dialog.close();
      });
    });

    this.dialog.addEventListener("click", this.handleDialogClose);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener("click", this.handleButtonClick);
    }
    if (this.dialog) {
      this.dialog.removeEventListener("close", this.handleDialogClose);
    }
  }

  handleButtonClick() {
    this.handleOverlay(true);
    const dialogToFadeIn = this.dialog.querySelector(".dialog") || this.dialog;
    dialogToFadeIn.classList.add("fade-in");
    dialogToFadeIn.showModal();
  }

  handleOverlay(open) {
    const style = open ? "block" : "none";
    const overlay = this.querySelector("[data-overlay]");
    if (overlay) overlay.style.display = style;
  }

  handleDialogClose(event) {
    if (!this.dialog) return;
    const rect = this.dialog.getBoundingClientRect();
    const isInDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (isInDialog) return;
    setTimeout(() => {
      this.handleOverlay(false);
      this.dialog.close();
    }, 400);

    if (this.dialog.querySelector(".dialog")) {
      this.dialog.querySelector(".dialog")?.classList.add("fade-in");
    } else {
      this.dialog.classList.remove("fade-in");
    }
  }
}
customElements.define("custom-dialog", CustomDialog);

class CountryDialog extends CustomDialog {
  constructor() {
    super();
    this.utils = new Utils();
  }

  connectedCallback() {
    super.connectedCallback();
    this.checkCountry();
  }

  async checkCountry() {
    if (Shopify.designMode) return;
    if (this.utils.getCookie("forceLocalization")) return;
    if (!this.dataset.userCountry) return;

    const url = "/browsing_context_suggestions.json";
    const response = await fetch(url);
    const result = await response.json();

    const navigationCountry = result.detected_values.country;
    if (navigationCountry.handle === this.dataset.userCountry) return;

    const backBtn = this.querySelector("[data-localization-back]");
    const select = this.querySelector("[data-localization-select]");
    const submit = this.querySelector("[data-localization-submit]");
    const localeInput = this.querySelector("[data-localization-locale]");
    const currentCountries = this.querySelectorAll("[data-country]");

    currentCountries.forEach((currentCountry) => {
      currentCountry.textContent = navigationCountry.name;
    });

    backBtn.addEventListener("click", () => {
      select.value = navigationCountry.handle;
      const targetCountry = select.querySelector(
        `option[value="${navigationCountry.handle}"]`
      );
      if (targetCountry?.dataset.marketDefaultLocale && localeInput) {
        localeInput.value = targetCountry.dataset.marketDefaultLocale;
      }
      submit.click();
    });

    this.querySelector("form").addEventListener("submit", () => {
      this.utils.setCookie("forceLocalization", true);
    });

    this.handleButtonClick();
  }
}
customElements.define("country-dialog", CountryDialog);
